import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react';
import CategoryEditor from './CategoryEditor';
import { toast } from 'react-toastify';
import { dataFileUrl, saveFileUrl } from '../../common/api';
import ActionButtons from '../../common/ActionButtons';
import { Icon } from '../../common/AppShell';
import Loader from '../../common/Loader/Loader';
import '../../index.css';

const Menu = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${dataFileUrl('data')}?t=${Date.now()}`)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        toast.error('Ошибка загрузки данных.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const categories = useMemo(() => (data ? Object.keys(data) : []), [data]);

  const visibleCategories = useMemo(() => {
    if (!data) return [];
    const normalizedSearch = search.trim().toLowerCase();

    return categories
      .filter((category) => activeCategory === 'all' || category === activeCategory)
      .map((category) => ({
        name: category,
        items: normalizedSearch
          ? data[category].filter((item) => item.name?.toLowerCase().includes(normalizedSearch))
          : data[category],
      }))
      .filter((category) => category.items.length > 0);
  }, [activeCategory, categories, data, search]);

  const handleCategoryUpdate = (category, updatedItems) => {
    setData((prevData) => ({
      ...prevData,
      [category]: updatedItems,
    }));
  };

  const saveData = () => {
    axios
      .put(saveFileUrl('data'), data)
      .then(() => toast.success('Данные успешно обновлены!'))
      .catch((error) => {
        console.error('Error saving data:', error);
        toast.error('Ошибка обновления данных.');
      });
  };

  if (loading) return <Loader />;

  return (
    <section className="screen-stack menu-screen">
      <div className="menu-tools">
        <label className="search-box">
          <Icon name="search" />
          <input
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Поиск по меню"
          />
        </label>
        <button type="button" className="filter-button" aria-label="Фильтры">
          <Icon name="tune" />
        </button>
      </div>

      <div className="category-chips">
        <button
          type="button"
          className={activeCategory === 'all' ? 'active' : ''}
          onClick={() => setActiveCategory('all')}
        >
          Все
        </button>
        {categories.map((category) => (
          <button
            type="button"
            className={activeCategory === category ? 'active' : ''}
            key={category}
            onClick={() => setActiveCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {visibleCategories.map((category) => (
        <CategoryEditor
          key={category.name}
          category={category.name}
          items={category.items}
          allItems={data[category.name]}
          onUpdate={(updatedItems) => handleCategoryUpdate(category.name, updatedItems)}
        />
      ))}

      <ActionButtons onBack={() => navigate('/')} onSave={saveData} />
    </section>
  );
};

export default Menu;
